import { message } from "antd";
import httpService from "../http/httpServices";
import axios from "axios";
import { Dispatch, SetStateAction } from "react";

const BASE_URL = process.env.REACT_APP_API_URL

export const handleFileUpload = async (e: any, width?: number, heigth?: number, setImageLoading?: Dispatch<SetStateAction<boolean>>,) => {
  console.log(e);
  let fd = new FormData()
  const ff = e.target.files[0]
  const image = new Image()
  image.src = URL.createObjectURL(ff)
  var imgWidth: any;
  let imgHeight: any;

  const uploadPromise = new Promise((resolve, reject) => {
    image.onload = function () {
      imgWidth = image.naturalWidth;
      imgHeight = image.naturalHeight;
      if ((heigth && imgHeight !== heigth) || (width && imgWidth !== width)) {
        reject(message.error(`Image dimensions must be ${width || 'variable'}x${heigth || 'variable'}`));
      } else {
        console.log(imgWidth, width, imgHeight, heigth);
        resolve(console.log("Image dimensions are correct"));
        if (setImageLoading) {
          setImageLoading(true);
        }
      }
    };
  });

  await uploadPromise; // Wait for the uploadPromise to resolve




  console.log(ff);
  fd.append('file', e.target.files[0])
  const config = {
    method: 'post',
    url: `${BASE_URL}/website/upload`,
    data: fd,
  }
  var url;

  await axios.post(`${BASE_URL}/website/upload`, fd)
    .then((res) => {
      console.log(res);
      url = res.data.preSignedUrl
      if (setImageLoading) {
        setImageLoading(false);
      }
    })
    .catch((err) => {
      message.error('File Not Uploaded')
    })

  return url
}